<template>
  <div class="c-media-gallery">
      <div ref="sliderAsNavFor" class="c-product-slider">
          <!-- NAVIGATION SLIDER (thumbnails) -->
          <div
            class="c-product-slider__nav js-slider-nav">
              <div
                v-for="(item, index) in urls"
                :key="index + item.url + '-thumbnails'"
                class="c-product-slider__nav-item js-slider-nav-item" >
                  <img
                    @click="selectNav(index)"
                    :data-src="item.url"
                    :alt="item.alt"
                    class="lazyload"
                    style="max-width:35px; max-height:70px;">
              </div>
          </div>
          <!-- MAIN IMAGE -->
          <div
            class="c-product-slider__main js-slider-main js-viewer-list">
              <div
                v-for="(item, index) in sliderMainImages"
                :key="item.url + '-MAIN' + index"
                class="carousel-cell c-media-gallery__slider-item js-slider-item">
                  <img
                    :data-src="item.url"
                    :alt="item.alt"
                    class="c-media-gallery__slider-image lazyload">
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import GetData from '~src/static/olu/colorz/utils/getData'

export default {
  computed: {
    ...mapGetters({
      currentProduct: 'GET_CURRENT_PRODUCT',
      productInformations: 'GET_PRODUCT_INFORMATIONS'
    }),
    urls () {
      return [...this.productInformations.images[this.currentProduct.sku]]
    }
  },
  data () {
    return {
      currentIndexImage: 0,
      flick: null,
      sliderMainImages: []
    }
  },
  watch: {
    urls (newUrls, oldUrls) {
      // make sure newUrls is actually different from the old urls
      if (!newUrls.every((item, index) => item.url === oldUrls[index].url)) {

        let sliderMain = document.querySelector('.js-slider-main')
        // Only pass this condition if flickity on main slider is enable
        if (sliderMain.classList && sliderMain.classList[3] === 'flickity-enabled') {
          // Remove Flickity functionality completely. destroy will return the element back to its pre-initialized state.
          this.flick.destroy()
          // Update array with newUrls
          this.sliderMainImages = newUrls
          // Initiate new flickity AFTER the dom has been updated by vuejs
          this.$nextTick(() => {
            this.createSlider()
            this.flick.resize()
          })
        }
      }
    }
  },
  beforeMount () {
    this.sliderMainImages = this.urls
  },
  mounted () {
    this.createSlider()
    this.flick.resize()
  },
  methods: {

    selectNav (index) {
      this.flick.select(index)
    },

    createSlider () {

      const el              = document.querySelector('.c-product-slider')
      const sliderMain      = el.querySelector('.js-slider-main')
      const align           = GetData(el, 'align') == null ? 'left' : GetData(el, 'align')
      const arrows          = GetData(el, 'arrows') == null ? false : GetData(el, 'arrows')

      const Flickity = window.Flickity

      this.flick = new Flickity( sliderMain, {
        wrapAround: true,
        cellAlign: align,
        cellSelector: '.js-slider-item',
        pageDots: false,
        prevNextButtons: arrows,
        arrowShape: 'M67.38,84.76L32.62,50 l34.76-34.76',
        selectedAttraction: 0.1,
        friction: 1,
        lazyLoad: 1
      })

      // prevent image viewer on dragMove, it has to be shown on click only
      this.flick.on( 'dragMove', ( event, pointer, moveVector )=>{
        sliderMain.style.pointerEvents = 'none'
      })
      // FIX IOS 15 : https://github.com/metafizzy/flickity/issues/1177#issuecomment-964056241
      this.flick.on( 'dragStart', ( event, pointer, moveVector )=>{
        document.ontouchmove = () => false
      })
      this.flick.on( 'dragEnd', ( event, pointer, moveVector )=>{
        sliderMain.style.pointerEvents = 'all'
        document.ontouchmove = () => true
      })
    }
  }
}
</script>
